
import React, { useEffect, useState } from "react"
import { useAuth } from "../../contexts/authContext"
import { Link, useHistory, useLocation } from "react-router-dom"
import googleLogoIcon from "./googleLogo.svg"
import "./auth.css"

export default function Signup() {
  const { login, loginWithGoogle, currentUser } = useAuth()
  const [error, setError] = useState("")
  const [loading, setLoading] = useState(false)
  const history = useHistory()
  const location = useLocation()
  
  useEffect(()=>{
    const goToPath = location.state && location.state.from ? location.state.from.pathname :"/serie/test/question/1"
    if(currentUser){
      history.push(goToPath);
    } 
  },[currentUser])
  
  async function handleSubmit(e) {
    e.preventDefault()
    const formData = [...new FormData(e.target)].reduce((acc,[key, value])=>{
        return({...acc, [key]:value});
      },{});

    try {
      setError("")
      setLoading(true)
      await login(formData.email, formData.password)
      // history.push(goToPath)
    } catch {
      setError("Failed to log in")
    }

    setLoading(false)
  }

  // const googleLogin =()=>{
  //   loginWithGoogle().then(()=>{
  //     setError("")
  //     setLoading(true)
  //     history.push(goToPath)
  //   }).catch(()=>{
  //     setError("Failed to log in")
  //   }).finally(()=>{
  //     setLoading(false)
  //   })
  // }  


  return (<div className="login-page">
    <div className="container">
        <h2>تسجيل الدخول</h2>
        {error && <div className="warning">{error}</div>}
        <form onSubmit={handleSubmit}>
            <input type="email" name="email" placeholder='البريد الإلكتروني' required/>
            {/* <span className="password-input">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M13.508 7.801C14.064 7.274 14.544 6.667 14.93 6H13.745C12.48 7.814 10.378 9 8 9C5.622 9 3.52 7.814 2.254 6H1.07C1.456 6.667 1.936 7.274 2.491 7.801L0.895996 9.396L1.604 10.103L3.26 8.446C3.97 8.969 4.771 9.378 5.634 9.645L5.017 11.866L5.981 12.134L6.607 9.879C7.06 9.96 7.525 10 8 10C8.475 10 8.94 9.959 9.392 9.88L10.018 12.134L10.982 11.866L10.365 9.645C11.228 9.378 12.028 8.969 12.739 8.445L14.396 10.103L15.104 9.396L13.509 7.801H13.508Z" fill="black"/>
</svg> */}

            <input type="password" name="password" placeholder="كلمة المرور" required/>
            {/* </span> */}
            <button type="submit" disabled={loading}>تسجيل الدخول</button>
        </form>
        <div className="log-link">
      ليس لديك حساب؟ &nbsp;&nbsp;<Link to="/signup">إنشاء حساب</Link>
      </div>
      <span className="separator">&nbsp;&nbsp;أو بإمكانك&nbsp;&nbsp;</span>
      <button className="oauth-btn" onClick={loginWithGoogle}><img src={googleLogoIcon}  alt="google logo"/>google تسجيل الدخول عبر</button>
    </div>
  </div>
  )
}
